import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, RockBottomLayers} from "../../view/RockBottomLayers";
import {gsap} from "gsap";
import {RockBottom} from "../../RockBottom";

export class ScatterNudgeView {

    private _layer: StageLayer;

    constructor() {
        this._layer = RockBottomLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    public showAddFreespin(position: PIXI.Point, noOfNudge: number): void {
        let steps: number;
        if(noOfNudge!==0){
            steps=3-noOfNudge;
        }else{
            steps=noOfNudge;
        }
        const sprite: PIXI.Sprite = new PIXI.Sprite(RockBottom.assetLoader.getTextures("plusOneSpin")[0]);
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(position.x, position.y + (steps * 100));
        sprite.scale.set(0.5, 0.5);
        sprite.name = "plusOneSpinImage";
        this._layer.addChild(sprite);

        gsap.to(sprite, 0.3, {alpha: 0, delay: 0.3});
        gsap.to(sprite, 0.5, {
            y: position.y - 25,
            onComplete: () => {
                this._layer.removeChild(sprite);
            }
        });
    }

}